import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import Button from '../components/ui/Button';
import { useSEO } from '../hooks/useSEO';

export default function NotFound() {
  const { t } = useLanguage();
  useSEO({ noindex: true });

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="max-w-lg mx-auto px-4 text-center">
        {/* 404 */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-transparent bg-gradient-to-r from-graweo-chocolate to-graweo-olive bg-clip-text">
            404
          </h1>
        </div>

        {/* Message */}
        <div className="mb-8">
          <h2 className="text-3xl sm:text-4xl font-bold font-manrope text-gray-900 mb-4">
            {t('notfound_title')}
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            {t('notfound_description')}
          </p>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button variant="primary" size="lg" className="w-full sm:w-auto">
              <Home className="w-4 h-4 mr-2" />
              {t('notfound_home')}
            </Button>
          </Link>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-3 text-gray-700 border-2 border-gray-300 hover:border-graweo-chocolate hover:text-graweo-chocolate font-semibold rounded-lg transition-all"
          >
            <ArrowLeft className="w-4 h-4 mr-2 inline-block" />
            {t('notfound_back')}
          </button>
        </div>

        {/* Decoration */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            {t('notfound_help')}
          </p>
          <div className="mt-4">
            <Link
              to="/contacts"
              className="inline-block text-graweo-chocolate hover:text-graweo-olive font-semibold transition-colors"
            >
              {t('notfound_contact')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
